var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickMarkGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.769,
    height: 14.373,
    viewBox: "0 0 18.769 14.373",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-checkmark",
    "data-name": "Icon ionic-ios-checkmark",
    d: "M29.1,13.888,27.57,12.311a.33.33,0,0,0-.244-.1h0a.317.317,0,0,0-.244.1L16.448,23.023l-3.87-3.87a.337.337,0,0,0-.488,0L10.539,20.7a.347.347,0,0,0,0,.5l4.881,4.881a1.544,1.544,0,0,0,1.02.5,1.617,1.617,0,0,0,1.011-.479h.009L29.113,14.385A.373.373,0,0,0,29.1,13.888Z",
    transform: "translate(-10.434 -12.206)",
    fill: "#06760a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickMarkGreen);
export default __webpack_public_path__ + "static/media/tick-mark-green.be84f9bbc1691c60b705fd2f26f705dd.svg";
export { ForwardRef as ReactComponent };